import { useGetUsersList } from '@apis/rendall/queries/use-get-users-list/use-get-users-list';
import { createOption } from '@packages/utils/create-options/create-options';

export const useGetUsersListOptions = () => {
  return useGetUsersList({
    select: ({ data }) =>
      data.map((user) => createOption(user.id ?? '', user.name)),
  });
};
